<template>
  <v-dialog
    v-model="dialog"
    transition="slide-y-transition"
    width="600"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card class="grey lighten-5">
      <v-card-title class="grey lighten-4">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = !dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            label="Código S.R.E. 2014"
            v-model="params.sre"
            :items="options.sre"
          />
          <v-autocomplete
            label="Nome da Rodovia"
            v-model="params.nome"
            :items="options.nome"
          />
          <v-combobox
            label="Visualização total"
            v-model="params.visualizacao"
            :items="options.visualizacao"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="reset()">Limpar</v-btn>
        <v-btn @click="addLayer()" color="primary">Pesquisar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//import axios from 'axios'
import * as L from 'leaflet'
import { getBounds } from '@/domain/library'

import { denominacaoRodovia, proxy } from '@/api/vue-exemplo'

export default {
  name: 'DenominacaoRodovias',
  data: () => ({
    name: 'der:denominacao_rodovia',
    title: 'Denominação de Rodovias',
    dialog: false,
    params: {
      sre: null,
      nome: null,
      visualizacao: null
    },
    options: {
      sre: null,
      nome: null,
      visualizacao: [
        {text: 'Todos os trechos com Denominação', value: 1},
        {text: 'Todos os trechos sem Denominação', value: 0}
      ]
    },
    template: [
      { text: 'Código SRE.2014', value: 'name' },
      //{ text: 'type', value: 'type' },
      //{ text: 'color', value: 'color' },
      { text: 'De', value: 'de' },
      { text: 'Para', value: 'para' },
      { text: 'Extensão (km)', value: 'ext' },
      { text: 'Nome da Rodovia', value: 'nomerod' },
      { text: 'Número da Lei', value: 'n.lei' },
      //{ text: 'pleitram', value: 'pleitram' },
      //{ text: 'nprojlei', value: 'nprojlei' },
      //{ text: 'inf.cgm', value: 'inf.cgm' },
      //{ text: 'show', value: 'show' },
      { text: 'Lei', value: 'lei' }
    ]
  }),
  mounted () {
    this.getSRE()
    this.getNome()
  },
  methods: {
    reset () {
      this.$refs.form.reset()

      this.removeLayer()
      this.$root.$emit('fitBounds', getBounds())

      this.dialog = false
    },
    addLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
        this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: this.name,
        srsName: 'EPSG:4674'
      }

      var paramsWms = {
        layers: this.name,
        format: 'image/png',
        transparent: true,
        pane: 'overlayPane',
        title: this.title
      }

      if (this.params.sre) {
        params.cql_filter = "name='" + this.params.sre + "'"
        paramsWms.cql_filter = params.cql_filter
      }
      if (this.params.nome) {
        params.cql_filter = "nomerod='" + this.params.nome + "'"
        paramsWms.cql_filter = params.cql_filter
      }
      if (this.params.visualizacao) {
        params.cql_filter = "show='" + this.params.visualizacao.value + "'"
        paramsWms.cql_filter = params.cql_filter
      }

      var ProxyWMS = L.TileLayer.WMS.extend({
        getTileUrl: function(coords) {
          var param = {
            url: L.TileLayer.WMS.prototype.getTileUrl.call(this, coords)
          }
          var proxy = process.env.VUE_APP_DER_API + '/geoProxy/geoserver'
          return proxy + L.Util.getParamString(param)
        }
      })

      this.wmsLayer = new ProxyWMS(process.env.VUE_APP_GEOSERVER, paramsWms)

      this.$root.$emit('addWmsLayer', this.wmsLayer, null, true)

      proxy.geoProxy({
        url: process.env.VUE_APP_GEOSERVER + L.Util.getParamString(params)
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            onEachFeature: (feature, layer) => {
              var popupContent = ""
              for (var header of this.template) {
                if (feature.properties[header.value]) {
                  popupContent += "<b>" + header.text + ":</b> "
                  if(header.value == "lei") {
                    popupContent += "<a target='blank' href=" + feature.properties[header.value] + ">Abrir</a><br>"
                  } else {
                    popupContent += feature.properties[header.value] + "<br>"
                  }
                }
              }

              layer.bindPopup(popupContent)
            },
            style: {
              opacity: 0
            }
          })

          this.$root.$emit('addGeoJson', this.geojson)
        })
        .catch(error => {
          console.log(error)
        })

      this.dialog = false
    },
    removeLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
        this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }
    },
    getSRE () {
      denominacaoRodovia.getSRE()
        .then(response => {
          this.options.sre = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getNome () {
      denominacaoRodovia.getNome()
        .then(response => {
          this.options.nome = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
